import React from "react";
import DialogSearch from "../DialogSearch";
import TileInsuranceSubType from "../../Tile/TileInsuranceSubType";
import PropTypes from "prop-types";
import InsuranceSubType from "../../../Utility/Crud/InsuranceSubType";
import MainContext from "../../../Context/MainContext/MainContext";

export default class DialogSearchInsuranceSubType extends DialogSearch {
  static contextType = MainContext; // For legacy class components

  /**
   * Searches for Insurance SubTypes by several name combinations or ID.
   *
   * @param {string} query The search query.
   * @returns A list of filtered insuranceSubTypes.
   */
  getSearchResults(query) {
    return InsuranceSubType.search(this.state.data, query, true);
  }

  /**
   * Gets the data that should be used in this dialog. Data can be manually
   * passed via the data prop, otherwise it falls back to the global list.
   *
   * @returns {array}
   */
  getData() {
    if (this.props.data) {
      return this.props.data;
    } else {
      return Object.values(this.context.insuranceSubTypesIndexed);
    }
  }

  /**
   * @param {object} insuranceSubType The insuranceSubType object.
   * @returns A TileInsuranceSubType component for this insuranceSubType.
   */
  renderTile(insuranceSubType) {
    return (
      <TileInsuranceSubType
        key={insuranceSubType.id}
        insuranceSubType={insuranceSubType}
      />
    );
  }
}
